(function(w,d,$){
  'use strict';
  if(!$) return;

  function dropdownParent(toggle){
    var selector=toggle.getAttribute('data-target');
    if(!selector){
      var href=toggle.getAttribute('href');
      if(href&&href.indexOf('#')!==-1) selector=href.replace(/.*(?=#[^\s]*$)/,'');
    }
    var parent=null;
    if(selector){
      try{ parent=d.querySelector(selector); }catch(e){}
    }
    return parent||toggle.parentNode;
  }

  function closeDropdowns(except){
    $('[data-toggle="dropdown"]').each(function(){
      var toggle=this,parent=dropdownParent(toggle);
      if(!parent||parent===except||!$(parent).hasClass('open')) return;
      var ev=$.Event('hide.bs.dropdown',{relatedTarget:toggle});
      $(parent).trigger(ev);
      if(ev.isDefaultPrevented()) return;
      $(toggle).attr('aria-expanded','false');
      $(parent).removeClass('open').trigger($.Event('hidden.bs.dropdown',{relatedTarget:toggle}));
    });
  }

  $(d).on('click.iceBootstrapShell','[data-toggle="dropdown"]',function(e){
    if($(this).is('.disabled, :disabled')) return;
    var parent=dropdownParent(this),isOpen=$(parent).hasClass('open');
    e.preventDefault();
    e.stopPropagation();
    closeDropdowns(parent);
    if(isOpen){
      var hideEv=$.Event('hide.bs.dropdown',{relatedTarget:this});
      $(parent).trigger(hideEv);
      if(hideEv.isDefaultPrevented()) return;
      $(this).attr('aria-expanded','false');
      $(parent).removeClass('open').trigger($.Event('hidden.bs.dropdown',{relatedTarget:this}));
      return;
    }
    var showEv=$.Event('show.bs.dropdown',{relatedTarget:this});
    $(parent).trigger(showEv);
    if(showEv.isDefaultPrevented()) return;
    $(this).attr('aria-expanded','true');
    $(parent).addClass('open').trigger($.Event('shown.bs.dropdown',{relatedTarget:this}));
  });

  $(d).on('click.iceBootstrapShell',function(e){
    if($(e.target).closest('.dropdown-menu').length) return;
    closeDropdowns();
  });

  $(d).on('keydown.iceBootstrapShell','[data-toggle="dropdown"], .dropdown-menu',function(e){
    if(e.which!==27) return;
    var parent=$(this).closest('.dropdown')[0]||dropdownParent(this);
    if(!parent) return;
    var toggle=$(parent).find('[data-toggle="dropdown"]').first();
    var hideEv=$.Event('hide.bs.dropdown',{relatedTarget:toggle[0]||null});
    $(parent).trigger(hideEv);
    if(hideEv.isDefaultPrevented()) return;
    $(parent).removeClass('open').trigger($.Event('hidden.bs.dropdown',{relatedTarget:toggle[0]||null}));
    if(toggle.length) toggle.attr('aria-expanded','false').focus();
  });

  if(typeof $.fn.dropdown!=='function'){
    $.fn.dropdown=function(action){
      return this.each(function(){ if(!action||action==='toggle') $(this).trigger('click'); });
    };
    $.fn.dropdown.Constructor={VERSION:'3.3.4-ice-shell'};
  }

  function closeAlert(trigger){
    var $trigger=$(trigger);
    var selector=$trigger.attr('data-target');
    if(!selector){
      var href=$trigger.attr('href');
      if(href&&href.indexOf('#')!==-1) selector=href.replace(/.*(?=#[^\s]*$)/,'');
    }
    var $alert=$();
    if(selector){
      try{ $alert=$(selector); }catch(err){}
    }
    if(!$alert.length) $alert=$trigger.closest('.alert');
    if(!$alert.length) return;
    var ev=$.Event('close.bs.alert');
    $alert.trigger(ev);
    if(ev.isDefaultPrevented()) return;
    $alert.removeClass('in').trigger('closed.bs.alert').remove();
  }

  $(d).on('click.iceBootstrapAlert','[data-dismiss="alert"]',function(e){
    e.preventDefault();
    closeAlert(this);
  });

  if(typeof $.fn.alert!=='function'){
    $.fn.alert=function(action){
      return this.each(function(){
        if(action==='close') closeAlert(this);
      });
    };
    $.fn.alert.Constructor={VERSION:'3.3.4-ice-shell'};
  }

  if(typeof $.fn.modal!=='function'){
    var activeModal=null,activeBackdrop=null,lastFocus=null;

    function modalOptions($modal,option){
      var data=$modal.data()||{};
      var supplied=$.isPlainObject(option)?option:{};
      return $.extend({backdrop:true,keyboard:true,show:true},data,supplied);
    }

    function removeBackdrop(){
      if(activeBackdrop){ activeBackdrop.remove(); activeBackdrop=null; }
      if(!$('.modal.in').length) $('body').removeClass('modal-open');
    }

    function showModal($modal,option,relatedTarget){
      if($modal.hasClass('in')) return;
      var opts=modalOptions($modal,option);
      var ev=$.Event('show.bs.modal',{relatedTarget:relatedTarget||null});
      $modal.trigger(ev);
      if(ev.isDefaultPrevented()) return;
      lastFocus=relatedTarget||d.activeElement;
      activeModal=$modal;
      $('body').addClass('modal-open');
      if(opts.backdrop){
        removeBackdrop();
        activeBackdrop=$('<div class="modal-backdrop fade"></div>').appendTo(d.body);
        if(activeBackdrop[0]) activeBackdrop[0].offsetWidth;
        activeBackdrop.addClass('in');
      }
      $modal.data('ice.modal.options',opts).css('display','block').attr({'aria-hidden':'false','aria-modal':'true'}).scrollTop(0);
      if($modal[0]) $modal[0].offsetWidth;
      $modal.addClass('in');
      w.setTimeout(function(){
        $modal.trigger($.Event('shown.bs.modal',{relatedTarget:relatedTarget||null}));
        var focus=$modal.find('[autofocus], .close, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
        if(focus.length) focus.focus();
      },0);
    }

    function hideModal($modal){
      if(!$modal.hasClass('in')&&$modal.css('display')==='none') return;
      var ev=$.Event('hide.bs.modal');
      $modal.trigger(ev);
      if(ev.isDefaultPrevented()) return;
      $modal.removeClass('in').attr('aria-hidden','true').removeAttr('aria-modal');
      w.setTimeout(function(){
        $modal.css('display','none');
        removeBackdrop();
        $modal.trigger('hidden.bs.modal');
        if(lastFocus&&d.documentElement.contains(lastFocus)&&typeof lastFocus.focus==='function') lastFocus.focus();
        if(activeModal&&activeModal[0]===$modal[0]) activeModal=null;
      },0);
    }

    $.fn.modal=function(option,relatedTarget){
      return this.each(function(){
        var $modal=$(this);
        if(option==='hide') hideModal($modal);
        else if(option==='toggle'){
          if($modal.hasClass('in')) hideModal($modal);
          else showModal($modal,{},relatedTarget);
        }else{
          var opts=modalOptions($modal,option);
          $modal.data('ice.modal.options',opts);
          if(opts.show!==false) showModal($modal,opts,relatedTarget);
        }
      });
    };
    $.fn.modal.Constructor={VERSION:'3.3.4-ice-shell'};

    $(d).on('click.iceBootstrapModal','[data-toggle="modal"]',function(e){
      var selector=$(this).attr('data-target')||($(this).attr('href')||'').replace(/.*(?=#[^\s]*$)/,'');
      if(!selector) return;
      var $modal;
      try{ $modal=$(selector); }catch(err){ return; }
      if(!$modal.length) return;
      e.preventDefault();
      $modal.modal('show',this);
    });

    $(d).on('click.iceBootstrapModal','[data-dismiss="modal"]',function(e){
      e.preventDefault();
      $(this).closest('.modal').modal('hide');
    });

    $(d).on('click.iceBootstrapModal','.modal',function(e){
      if(e.target!==this) return;
      var $modal=$(this),opts=$modal.data('ice.modal.options')||{};
      if(opts.backdrop==='static') return;
      $modal.modal('hide');
    });

    $(d).on('keydown.iceBootstrapModal',function(e){
      if(e.which!==27||!activeModal||!activeModal.hasClass('in')) return;
      var opts=activeModal.data('ice.modal.options')||{};
      if(opts.keyboard!==false) activeModal.modal('hide');
    });
  }
}(window,document,window.jQuery));
